import React from 'react';
import { RecentlyReadContentDto } from '@diritto/common/recentlyRead/dtos/recently-read.dto';
import { ContentRelayDto, ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { EpisodeRelayDto } from '@diritto/common/relay/dtos/episode-relay.dtos';
import { Color } from '@diritto/common/style/color';
import { Link } from 'ui-components/common/Link';
import { ProgressBar } from 'ui-components/common/ProgressBar';
import { useReadContinueOrNext } from 'state-hooks/episode/useReadContinueOrNext';
import { ContentBadgeGroup } from '@/ui-components/contents/ContentBadgeGroup';
import { BadgeMode } from '@/constants/badge';

interface SectionRecentlyReadContentTextItemProps {
  recentlyReadContent: RecentlyReadContentDto;
  contents: Record<number, ContentRelayDto>;
  episodes: Record<number, EpisodeRelayDto>;
  onClick?: () => void;
}

export const SectionRecentlyReadContentTextItem = ({
  recentlyReadContent,
  contents,
  episodes,
  onClick,
}: SectionRecentlyReadContentTextItemProps) => {
  const content = contents[recentlyReadContent.contentId];
  const episode = episodes[recentlyReadContent.episodeId];

  const readContinueOrNext = useReadContinueOrNext(content, episode, recentlyReadContent);

  if (!readContinueOrNext) {
    return null;
  }

  const validContent = content as ContentPublicRelayDto;

  return (
    <div onClick={onClick} className="w-[169px] h-[135px] flex-shrink-0">
      <Link href={readContinueOrNext.link}>
        <div className="flex flex-col justify-between w-full h-full p-4 bg-gray-100 cursor-pointer border border-solid border-[#0000000A] rounded-md">
          <div className="flex flex-col gap-1">
            <ContentBadgeGroup content={validContent} mode={BadgeMode.TEXT} />
            <div className="text-black font-medium text-xs leading-6 h-12 line-clamp-2 overflow-hidden text-ellipsis break-all">
              {validContent.title}
            </div>
          </div>
          <div className="flex flex-col gap-0.5">
            <div className="text-gray-500 font-regular text-xxxs leading-[18px]">{readContinueOrNext.buttonText}</div>
            {readContinueOrNext.position !== undefined && (
              <div className="w-full h-1 rounded-[10px] overflow-hidden">
                <ProgressBar
                  className="w-full h-full"
                  color={Color.Primary500}
                  backgroundColor={Color.Gray500}
                  progress={recentlyReadContent.position}
                />
              </div>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};
